import * as React from 'react';

import { Box, Button, Container, CssBaseline, Grid,  Link,  ListItemButton,  ListItemIcon,  ListItemText,  MenuItem,  Typography } from "@mui/material";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import AddIcon from '@mui/icons-material/Add';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { useEffect } from 'react';
import axiosInstance from '../../axiosInstance';
import { string } from 'yup';
import { useNavigate } from 'react-router-dom';


// const rows = [
//   createData('India', 'IN', 1324171354, 3287263),
//   createData('China', 'CN', 1403500365, 9596961),
//   createData('Italy', 'IT', 60483973, 301340),
//   createData('United States', 'US', 327167434, 9833520),
//   createData('Canada', 'CA', 37602103, 9984670),
//   createData('Australia', 'AU', 25475400, 7692024),
//   createData('Germany', 'DE', 83019200, 357578),
//   createData('Ireland', 'IE', 4857000, 70273),
//   createData('Mexico', 'MX', 126577691, 1972550),
//   createData('Japan', 'JP', 126317000, 377973),
//   createData('France', 'FR', 67022000, 640679),
//   createData('United Kingdom', 'GB', 67545757, 242495),
//   createData('Russia', 'RU', 146793744, 17098246),
//   createData('Nigeria', 'NG', 200962417, 923768),
//   createData('Brazil', 'BR', 210147125, 8515767),
// ];
const defaultTheme = createTheme();
export default function SlideList (){
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [slideList,setslideList]= React.useState([]);
  const [totalPage, settotalPage] = React.useState(0);
  const navigate = useNavigate();

  const routeChange = () =>{ 
    navigate('/admin/addslide');
  }
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getListData(rowsPerPage,newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    getListData(+event.target.value,0);
  };
  function getListData(nrowsPerPage,npage){
    axiosInstance.get('Slide/GetSlideMasters/?PageSize='+ nrowsPerPage +'&PageIndex=' +  (parseInt(npage)+1)).then((response)=>{
      console.log(response.data);
      console.log(response.data.Data);
      console.log(response.data.TotalCount)
      setslideList(response.data.Data);
      settotalPage(response.data.TotalCount);
     });
  }
  useEffect(()=>{
    // axiosInstance.get('slide/GetslideMasters/?PageSize='+ rowsPerPage +'&PageIndex=' +  (parseInt(page)+1)).then((response)=>{
    //   console.log(response.data);
    //   setslideList(response.data);
    //  });
    getListData(rowsPerPage,page);
  },[])
    return(

      <ThemeProvider theme={defaultTheme}>
          <Container component="main" >
            <CssBaseline />
            <Box
              sx={{
                marginTop: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                '& .MuiTextField-root': { m: 1 },
              }}
            >
              
              
              <Box sx={{ width: '100%' }}>
              
                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                  <Grid item xs={6}>
                    <Button 
                      startIcon={<AddIcon />} onClick={routeChange}>
                      Add Slide
                    </Button>
                    
                  </Grid>
                  <Grid item xs={6}>
                      <Typography component="h6" variant="h6">
                        Slide list
                      </Typography>
                    
                  </Grid>
                  <Grid item xs={6}>
                  
                  </Grid>
                  <Grid item xs={6}>
                  
                  </Grid>
                  <Grid item xs={12}>
                  <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                      <TableContainer sx={{ maxHeight: 440 }}>
                        <Table stickyHeader aria-label="sticky table">
                          <TableHead>
                            <TableRow>
                              {/* {columns.map((column) => (
                                <TableCell
                                  key={column.id}
                                  align={column.align}
                                  style={{ minWidth: column.minWidth }}
                                >
                                  {column.label}
                                </TableCell>
                              ))} */}
                              <TableCell>
                                SNo
                              </TableCell>
                              <TableCell>
                                Name
                              </TableCell>
                             
                              <TableCell>
                                Status
                              </TableCell>
                              <TableCell>
                                
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {slideList?.map((item,index)=>(
                              
                              <TableRow key={item.SlideID}>
                                  <TableCell>
                                    {index+1}
                                  </TableCell>
                                  <TableCell>
                                    {/* {item.slideName} */}
                                    {item.SlideName}
                                  </TableCell>
                                  
                                  <TableCell>
                                    {String(item.IsActive)}
                                  </TableCell>
                                  <TableCell>
                                    <Link href={`/admin/addslide/${item.SlideID}`}>Edit</Link>
                                  </TableCell>
                              </TableRow>
                            ))}
                            
                            
                          </TableBody>
                        </Table>
                      </TableContainer>
                      <TablePagination
                        rowsPerPageOptions={[1,10, 25, 100]}
                        component="div"
                        count={totalPage}
                        rowsPerPage={rowsPerPage} 
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                      />
                    </Paper>
                  </Grid>
                </Grid>
              </Box>
            </Box>
            
          </Container>
        </ThemeProvider>



    
    )
}